import React from 'react';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages.js';
import { FormattedMessage, useIntl } from 'react-intl';
import { MUTATION_REMOVE_EXERCISES_FROM_TEMPLATES } from 'services/aws/templates-query';
import { useNotificationQueue } from 'components/notification';
import { useStore } from 'stores/Store';

const RemoveExercisesFromTemplateButton = ({
  entityId,
  exerciseIds,
  templateId,
  type = 'template',
  updated,
  disabledMessage,
  ...props
}) => {
  const intl = useIntl();
  const notification = useNotificationQueue();
  const selectedExercises = useStore(state => state.selectedExercises);

  return (
    <ConfirmMutationButton
      menu
      {...props}
      mutation={MUTATION_REMOVE_EXERCISES_FROM_TEMPLATES}
      confirmTitle={messages.modalConfirmRemoveExerciseFromTemplateTitle}
      confirmMessage={messages.modalConfirmRemoveExerciseFromTemplateMessage}
      messageValues={{ count: selectedExercises.length, type }}
      variables={{
        programTemplateIds: [templateId],
        exerciseIds: selectedExercises.map(exercise => exercise.id)
      }}
      update={(cache, { data: { removeExercisesFromProgramTemplates } }) => {
        if (removeExercisesFromProgramTemplates) {
          notification.add(templateId, {
            message: intl.formatMessage(messages.messageEditTemplateSuccess)
          });
          updated && updated();
        }
      }}
    >
      {disabledMessage && props.disabled ? (
        <>
          <Icon id="delete" style={{ top: 'auto' }} />
          <span>{disabledMessage}</span>
        </>
      ) : (
        <>
          <Icon
            id="delete"
            style={{ top: 'auto' }}
            strokeColor={'color-neutral-dark'}
          />
          {/* // TODO: check translation fabian */}
          <FormattedMessage
            {...messages.exercisesRemoveExerciseFromTemplateButton}
            values={{ count: selectedExercises.length, type }}
          />
        </>
      )}
    </ConfirmMutationButton>
  );
};

export default RemoveExercisesFromTemplateButton;
